module.exports = __webpack_public_path__ + "static/media/goodrej range.a3ac9c5b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/goodrej range.gif
// module id = 382
// module chunks = 0